// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_1rUUq","badgeButtonWrapper":"_1rUUq","badge-button":"efUsS","badgeButton":"efUsS","badge":"_3gDi_"};